import { getCompareItems, removeCompareItem } from './comparador-storage.js';

export default function initComparePage() {
    const appContainer = document.getElementById('js-compare-app');
    const controlsContainer = document.getElementById('js-compare-controls');
    const highlightToggle = document.getElementById('js-compare-highlight');

    if (!appContainer) return;

    const localItems = getCompareItems();

    if (localItems.length === 0) {
        appContainer.innerHTML = `
            <div class="c-compare-empty">
                <div class="wrapper">
                    <div class="c-compare-empty__wrapper">
                        <h2 class="c-compare-empty__title">Seu comparador está vazio.</h2>
                        <p class="c-compare-empty__text">Navegue pelos nossos produtos e adicione-os ao comparador.</p>
                        <a href="/produtos" class="c-compound-btn">
                            <span class="c-compound-btn__label">
                                CONTINUAR NAVEGANDO
                            </span>
                            <span class="c-compound-btn__icon">
                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.7071 8.07039C23.0976 7.67987 23.0976 7.0467 22.7071 6.65618L16.3431 0.292215C15.9526 -0.0983096 15.3195 -0.0983096 14.9289 0.292215C14.5384 0.682739 14.5384 1.3159 14.9289 1.70643L20.5858 7.36328L14.9289 13.0201C14.5384 13.4107 14.5384 14.0438 14.9289 14.4344C15.3195 14.8249 15.9526 14.8249 16.3431 14.4344L22.7071 8.07039ZM0 7.36328L-8.74228e-08 8.36328L22 8.36328L22 7.36328L22 6.36328L8.74228e-08 6.36328L0 7.36328Z" fill="white" />
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        `;
        return;
    }

    const idsString = localItems.map(item => item.id).join(',');

    appContainer.innerHTML = `
        <div class="c-compare-loading">
            <div class="wrapper">
                <p>Carregando...</p>
                <div class="c-compare-loading__spinner"></div>
            </div>
        </div>
    `;

    fetch(`/wp-json/pdr/v1/comparador?ids=${idsString}`)
        .then(response => {
            if (!response.ok) throw new Error('Erro na rede');
            return response.json();
        })
        .then(data => {
            appContainer.innerHTML = '';
            renderApp(data.products, data.masterSpecs || data.master_specs);
        })
        .catch(error => {
            console.error('Erro:', error);
            appContainer.innerHTML = '<p class="c-compare-error">Erro ao carregar especificações.</p>';
        });

    function renderApp(products, masterSpecs) {
        if (products.length === 1) {
            const p = products[0];
            appContainer.innerHTML = `
            <div class="c-compare-single">
                <div class="wrapper c-compare-single__wrapper">
                    <article class="c-compare-card">
                        <div class="c-compare-card__mask">
                            <img src="${p.image}" alt="${p.title}" class="c-compare-card__image">
                        </div>
                    </article>

                    <div class="c-compare-single__invite">
                        <h3>Opa, você tirou um produto da comparação</h3>
                        <p>Você não tem nenhum produto para comparar com <a href="${p.link}">${p.title}</a>.</p>
                        <a href="/produtos" class="c-compound-btn">
                            <span class="c-compound-btn__label">
                                CONTINUAR NAVEGANDO
                            </span>
                            <span class="c-compound-btn__icon">
                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.7071 8.07039C23.0976 7.67987 23.0976 7.0467 22.7071 6.65618L16.3431 0.292215C15.9526 -0.0983096 15.3195 -0.0983096 14.9289 0.292215C14.5384 0.682739 14.5384 1.3159 14.9289 1.70643L20.5858 7.36328L14.9289 13.0201C14.5384 13.4107 14.5384 14.0438 14.9289 14.4344C15.3195 14.8249 15.9526 14.8249 16.3431 14.4344L22.7071 8.07039ZM0 7.36328L-8.74228e-08 8.36328L22 8.36328L22 7.36328L22 6.36328L8.74228e-08 6.36328L0 7.36328Z" fill="white" />
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
                `;
            bindDeleteEvents();
            return;
        }

        controlsContainer.style.display = 'flex';

        const generalLabels = ['Marca', 'Tipo', 'Cores'];
        const technicalLabels = masterSpecs.filter(label => !generalLabels.includes(label));
        const differentSpecs = getDifferences(products, masterSpecs);

        const gridClass = products.length === 2 ? 'c-compare-grid--2cols' : 'c-compare-grid--3cols';
        let html = `<div class="c-compare-grid ${gridClass}">`;

        // ==========================================
        // ROW 1: HEADER (PRODUTOS)
        // ==========================================
        html += `
                <div class="c-compare-section c-compare-section--header">
                    <div class="wrapper c-compare-section__wrapper">
            `;

        // O Invite SÓ aparece se tivermos 2 produtos
        if (products.length === 2) {
            html += `
                    <div class="c-compare-labels c-compare-labels--header">
                        <div class="c-compare-invite">
                            <div class="c-compare-invite__icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--blue)" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
                            </div>
                            <p>Navegue e adicione mais produtos para comparar</p>
                        </div>
                    </div>
                `;
        }

        html += `
                    <div class="swiper js-compare-products c-compare-row-slider">
                        <div class="swiper-wrapper">
            `;
        products.forEach(p => {
            html += `
                    <div class="swiper-slide c-compare-col">
                        <article class="c-compare-card">
                            <button type="button" class="c-compare-card__delete js-page-delete" data-id="${p.id}" aria-label="Remover">
                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 1L1 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 1L10 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                            
                            </button>
                            <a href="${p.link}">
                                <div class="c-compare-card__mask">
                                    <img src="${p.image}" alt="${p.title}" class="c-compare-card__image">
                                </div>
                                <h3 class="c-compare-card__title">${p.title}</h3>
                            </a>
                        </article>
                    </div>
                `;
        });
        html += `
                        </div>

                        <div class="swiper-pagination swiper-pagination-comparador"></div>
                        
                    </div>

                    <div class="swiper-button-prev swiper-button-comparador">
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.66667 1L1.30858 6.11454C0.895882 6.50848 0.895882 7.16731 1.30858 7.56125L6.66666 12.6758" stroke="#182579" stroke-width="2" stroke-linecap="round"/>
                            <line x1="1.55078" y1="6.67188" x2="17.3424" y2="6.67188" stroke="#182579" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>

                    <div class="swiper-button-next swiper-button-comparador">
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.6771 12.6758L17.0352 7.56125C17.4479 7.16731 17.4479 6.50847 17.0352 6.11453L11.6771 0.999999" stroke="#182579" stroke-width="2" stroke-linecap="round"/>
                            <line x1="16.793" y1="7.00586" x2="1.0013" y2="7.00586" stroke="#182579" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                </div>
            </div>
            `;

        // ==========================================
        // ROW 2: ESPECIFICAÇÕES GERAIS
        // ==========================================
        html += `
                <div class="c-compare-section c-compare-section--specs">
                <div class="wrapper c-compare-section__wrapper">
                    <div class="c-compare-section__body">
                        <div class="c-compare-labels">
                            <dl class="c-compare-list">
            `;
        // Labels Flutuantes (Usadas no celular e no Desktop 2 Colunas)
        generalLabels.forEach(label => {
            html += `<div class="c-compare-item c-compare-item--label-only"><dt class="c-compare-item__label">${label}</dt></div>`;
        });
        html += `
                            </dl>
                        </div>
                        <div class="swiper js-compare-general c-compare-row-slider">
                            <div class="swiper-wrapper">
            `;
        // Produtos
        products.forEach(p => {
            html += '<div class="swiper-slide c-compare-col"><dl class="c-compare-list">';
            generalLabels.forEach(label => {
                const diffClass = differentSpecs.has(label) ? 'is-different' : '';
                const val = p.specs[label] || '—';
                html += `
                        <div class="c-compare-item c-compare-item--value-only ${diffClass}">
                            <dt class="c-compare-item__label c-compare-item__label--inline">${label}</dt>
                            <dd class="c-compare-item__value">${val}</dd>
                        </div>
                    `;
            });
            html += '</dl></div>';
        });
        html += `       </div>
                        </div>
                    </div>
                </div>
            </div>
            `;

        // ==========================================
        // ROW 3: ESPECIFICAÇÕES TÉCNICAS
        // ==========================================
        if (technicalLabels.length > 0) {
            html += `
                    <div class="c-compare-section c-compare-section--specs">
                    <div class="wrapper c-compare-section__wrapper">
                        <h4 class="c-compare-section__title">Especificações Técnicas</h4>
                        <div class="c-compare-section__body">
                            <div class="c-compare-labels">
                                <dl class="c-compare-list">
                `;
            technicalLabels.forEach(label => {
                html += `<div class="c-compare-item c-compare-item--label-only"><dt class="c-compare-item__label">${label}</dt></div>`;
            });
            html += `
                                </dl>
                            </div>
                            <div class="swiper js-compare-technical c-compare-row-slider">
                                <div class="swiper-wrapper">
                `;
            products.forEach(p => {
                html += '<div class="swiper-slide c-compare-col"><dl class="c-compare-list">';
                technicalLabels.forEach(label => {
                    const diffClass = differentSpecs.has(label) ? 'is-different' : '';
                    const val = p.specs[label] || '—';
                    html += `
                            <div class="c-compare-item c-compare-item--value-only ${diffClass}">
                                <dt class="c-compare-item__label c-compare-item__label--inline">${label}</dt>
                                <dd class="c-compare-item__value">${val}</dd>
                            </div>
                        `;
                });
                html += '</dl></div>';
            });
            html += `       </div>
                            </div>
                        </div>
                    </div>
                </div>
                `;
        }

        html += '</div>';
        appContainer.innerHTML = html;

        initSwipers(products.length); // Passei o length para corrigir as colunas iniciais do Swiper
        bindDeleteEvents();

        // Chama o nosso equalizador logo após renderizar
        syncRowHeights();

        // Se o usuário virar o celular de lado, o texto muda de tamanho. 
        // Isso garante que a altura se ajuste automaticamente!
        window.addEventListener('resize', syncRowHeights);
    }

    function getDifferences(products, masterSpecs) {
        const diffs = new Set();
        masterSpecs.forEach(label => {
            const values = products.map(p => p.specs[label] || '—');
            const uniqueValues = new Set(values);
            if (uniqueValues.size > 1) diffs.add(label);
        });
        return diffs;
    }

    if (highlightToggle) {
        highlightToggle.addEventListener('change', (e) => {
            e.target.checked
                ? appContainer.classList.add('is-highlighting-diffs')
                : appContainer.classList.remove('is-highlighting-diffs');
        });
    }

    function bindDeleteEvents() {
        appContainer.querySelectorAll('.js-page-delete').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                removeCompareItem(btn.getAttribute('data-id'));
                window.location.reload();
            });
        });
    }

    function initSwipers() {
        if (typeof Swiper === 'undefined') return;

        // 1. Configurações Base (iguais para todos)
        // Mudei o nome aqui para baseOptions para bater com o código de baixo!
        const baseOptions = {
            slidesPerView: 'auto',
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            watchOverflow: true,
            controller: {
                by: 'slide',
            },
            breakpoints: {
                992: {
                    enabled: false,
                    slidesPerView: 3,
                    spaceBetween: 0,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                }
            }
        };

        // 2. Inicia o Carrossel de PRODUTOS (Com o seu spaceBetween customizado)
        const swiperProd = new Swiper('.js-compare-products', {
            ...baseOptions,
            spaceBetween: 12,
            pagination: {
                el: '.swiper-pagination.swiper-pagination-comparador',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-comparador',
                prevEl: '.swiper-button-prev.swiper-button-comparador',
            }
        });

        // 3. Inicia os Carrosséis de ESPECIFICAÇÕES (Com o espaço zerado)
        const swiperGen = new Swiper('.js-compare-general', {
            ...baseOptions,
            spaceBetween: 0, // <--- Espaçamento zerado nas tabelas
        });

        const techEl = document.querySelector('.js-compare-technical');
        const swiperTech = techEl ? new Swiper('.js-compare-technical', {
            ...baseOptions,
            spaceBetween: 0, // <--- Espaçamento zerado nas tabelas
        }) : null;

        // Sincronia
        if (swiperTech) {
            swiperProd.controller.control = [swiperGen, swiperTech];
            swiperGen.controller.control = swiperProd;
            swiperTech.controller.control = swiperProd;
        } else {
            swiperProd.controller.control = swiperGen;
            swiperGen.controller.control = swiperProd;
        }

        // Paginação e Navegação
        swiperProd.params.navigation.nextEl = '.swiper-button-next';
        swiperProd.params.navigation.prevEl = '.swiper-button-prev';
        swiperProd.navigation.init();
        swiperProd.navigation.update();
    }

    // ==========================================
    // EQUALIZADOR DE ALTURAS DAS LINHAS
    // ==========================================
    function syncRowHeights() {
        // Seleciona as seções de tabela (Gerais e Técnicas)
        const sections = document.querySelectorAll('.c-compare-section--specs');

        sections.forEach(section => {
            // Pega todas as listas dessa seção (a lista de títulos flutuantes + as listas dos produtos)
            const lists = section.querySelectorAll('.c-compare-list');
            if (lists.length === 0) return;

            // Descobre quantas linhas (specs) temos nessa seção
            const numRows = lists[0].children.length;

            for (let i = 0; i < numRows; i++) {
                let maxHeight = 0;
                let cellsAtThisRow = [];

                // 1. Coleta todas as células da mesma "linha" horizontal em todas as colunas
                lists.forEach(list => {
                    const cell = list.children[i];
                    if (cell) {
                        cell.style.height = 'auto'; // Reseta a altura para o CSS calcular o tamanho natural
                        cellsAtThisRow.push(cell);
                    }
                });

                // 2. Descobre qual célula ficou mais alta por causa do texto
                cellsAtThisRow.forEach(cell => {
                    if (cell.offsetHeight > maxHeight) {
                        maxHeight = cell.offsetHeight;
                    }
                });

                // 3. Aplica essa altura máxima a todas as células daquela linha
                cellsAtThisRow.forEach(cell => {
                    cell.style.height = `${maxHeight}px`;
                });
            }
        });
    }
}